module.exports = __webpack_public_path__ + "img/logo-ek.993695ef.png";